export class Ajax {
    
    /*
	 * Init the handler 
	 * @param  {string} term_id
     * @param  {string} type
	 */
    
    getPriceBand(term_id, form = '' ) {

        const settings = {
            action: 'load_pricing_band',
            nonce: ajax_params.ajaxNonce,
            term_id: term_id,
            form: form
        }

        const loader = document.getElementById('price-band-loader')
        loader.innerHTML = '<div class="price-band-loading">Loading...</div>';
        
        fetch(ajax_params.ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(settings),
        })
        .then(function (response) {
            if (response.ok) {
				return response.text()
			}
			throw new Error('Something went wrong')
        })
        .then((data) => {
            loader.innerHTML = data
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error);
        })
    }
}